import type { Plan } from '@/utils/mapProductObject';
import type { StripeElementsOptionsMode } from '@stripe/stripe-js';

export const buildExpressElementsOptions = (plan: Plan) => {
  const mode = plan.hasTrial ? 'setup' : 'payment';

  const options = {
    mode,
    currency: plan.paymentRequest.currency,
    paymentMethodCreation: 'manual',
    ...(mode !== 'setup' && { amount: plan.paymentRequest.amount }),
    appearance: {
      variables: {
        borderRadius: '16px',
      },
    },
  } as StripeElementsOptionsMode;

  return options;
};
